import React from "react";
import { FilePreviewProps } from "./definitions";
import { isFileTypePreviewable } from "./utils";

export const FilePreview: React.FC<FilePreviewProps> = ({
  type,
  fileName,
  presignedUrl,
}) => {
  const getFileType = (type: string) => {
    const extension = type.split(".").pop()?.toLowerCase();
    return extension;
  };

  const renderPreview = () => {
    const fileType = type ? getFileType(type) : "";

    if (!isFileTypePreviewable(type)) {
      return (
        <p data-testid="preview-not">
          Preview not available for this file type.{" "}
        </p>
      );
    }

    switch (fileType) {
      case "txt":
      case "json":
      case "pdf":
        return (
          <iframe
            src={presignedUrl}
            width="100%"
            height="900px"
            data-testid="preview-iframe"
          />
        );
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
      case "bmp":
      case "webp":
        return (
          <img
            src={presignedUrl}
            alt={fileName}
            style={{ maxWidth: "100%", height: "auto" }}
            data-testid="preview-img"
          />
        );
      case "mp4":
      case "webm":
      case "ogg":
        return (
          <video controls width="100%" data-testid="preview-video">
            <source
              src={presignedUrl}
              type={`video/${fileType}`}
              data-testid="video-source"
            />
            Your browser does not support the video tag.
          </video>
        );
      case "mp3":
      case "wav":
      case "aac":
      case "flac":
        return (
          <audio controls data-testid="preview-audio">
            <source
              src={presignedUrl}
              type={`audio/${fileType}`}
              data-testid="audio-source"
            />
            Your browser does not support the audio element.
          </audio>
        );
      default:
        return (
          <p data-testid="preview-not">
            Preview not available for this file type.{" "}
          </p>
        );
    }
  };

  return <div>{renderPreview()}</div>;
};
